
































import { defineComponent, reactive, toRefs, computed, onMounted, PropType, watch, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import isMobileJS from 'ismobilejs';
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 500, interval: 0})
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { SheetField, FieldActivity, TensakuText } from "../modules/teacher/SaitenInput";
import * as SaitenInput from "../modules/teacher/SaitenInput";

export interface Data {
  markSize: number
  isDrawing: boolean
  isTouching: boolean
  isTouchScoringEnable: boolean
  startPos: Common.Point
  endPos: Common.Point
  pagePos: Common.Point
  isDragging: boolean
  isResizing: boolean
  drawModeCache: number
  isCanvasLeaded: boolean
  dragMinRange: number
  isStampTouching: boolean
  clickedTensakuText: TensakuText
  isScrolling: boolean
  scrollPos: Common.Point
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  props: {
    sheetField: {
      type: SheetField as PropType<SheetField>,
      required: true
    },
    fieldActivity: {
      type: FieldActivity as PropType<FieldActivity>,
      required: true
    },
    sheet_id: {
      type: String as PropType<string>,
      required: true
    },
    idx: {
      type: Number as PropType<number>,
      required: true
    },
    selectedIdx: {
      type: Number as PropType<number>,
      required: true
    },
    scale: {
      type: Number as PropType<number>,
      required: true
    },
    thickness: {
      type: Number as PropType<number>,
      required: true
    },
    fieldPadding: {
      type: Number as PropType<number>,
      required: true
    },
    fieldMargin: {
      type: Number as PropType<number>,
      required: true
    },
    fieldWrapWidth: {
      type: Number as PropType<number>,
      required: true
    },
    fieldWrapHeight: {
      type: Number as PropType<number>,
      required: true
    },
    fieldImageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    fieldImageHeight: {
      type: Number as PropType<number>,
      required: true
    },
    drawMode: {
      type: Number as PropType<number>,
      required: true
    },
    keyCode: {
      type: String as PropType<string>,
      required: true
    },
    drawColor: {
      type: String as PropType<string>,
      required: true
    },
    direction: {
      type: Number as PropType<number>,
      required: true
    },
    fontSize: {
      type: Number as PropType<number>,
      default: null,
    },
    lineHeight: {
      type: Number as PropType<number>,
      default: null,
    },
    selectedTensakuText: {
      type: TensakuText || null as PropType<TensakuText | null>,
      required: false,
      default: null,
    },
  },
  components: {
    "vue-drag-resize": VueDragResize,
  },
  setup (props, context) {

    const DrawModeEnum = Common.DrawModeEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      markSize: 50,
      isDrawing: false,
      isTouching: false,
      isTouchScoringEnable: true,
      startPos: new Common.Point(0, 0),
      endPos: new Common.Point(0, 0),
      pagePos: new Common.Point(0, 0),
      isDragging: false,
      isResizing: false,
      drawModeCache: null,
      isCanvasLeaded: false,
      dragMinRange: 1,
      isStampTouching: false,
      clickedTensakuText: null,
      isScrolling: false,
      scrollPos: new Common.Point(0, 0),
    });

    /************************************************************
     * 得点スタンプのCSSスタイル
     ************************************************************/

    const stampStyle = computed((): any => {
      const style: any = {};
      style["z-index"] = isTensakuMode.value ? 2 : 3;
      return style;
    });

    /************************************************************
     * canvasタグのCSS
     ************************************************************/

    const canvasStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.fieldImageWidth}px`;
      style["height"] = `${props.fieldImageHeight}px`;
      style["z-index"] = isTensakuMode.value ? 3 : 2;
      return style;
    });
    
    /************************************************************
     * 切り出し画像の親DivのCSS
     ************************************************************/

    const fieldWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.fieldWrapWidth}px`;
      style["height"] = `${props.fieldWrapHeight}px`;
      style["padding"] = `${props.fieldPadding}px`;
      style["margin-left"] = `${props.fieldMargin}px`;
      style["margin-right"] = `${props.fieldMargin}px`;

      if(props.fieldActivity.correct_state == null){
        style["background-color"] = "#c0c0e2";
      }else if(props.fieldActivity.correct_state == 1){
        style["background-color"] = "#31b0e4";
      }else if(props.fieldActivity.correct_state == -1){
        style["background-color"] = "pink";
      }else if(props.fieldActivity.correct_state == 0){
        style["background-color"] = "#cfd609";
      }

      if(props.selectedIdx == props.idx){
        style["box-shadow"] = "0 0 4px 4px blue";
      }
      return style;
    });

    /************************************************************
     * 切り出し画像div・imgタグ・canvasタグのCSS
     ************************************************************/

    const fieldImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.fieldImageWidth}px`;
      style["height"] = `${props.fieldImageHeight}px`;
      return style;
    });

    /************************************************************
     * ヘッダー出席番号のCSS
     ************************************************************/

    const headerStyle = computed((): any => {
      const style: any = {};
      style["margin-left"] = `${props.fieldMargin}px`;
      return style;
    });

    /************************************************************
     * 採点マークimgタグのCSS
     ************************************************************/

    const markImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.markSize}px`;
      style["height"] = `${state.markSize}px`;
      return style;
    });

    /************************************************************
     * 採点マーク部分点spanタグのCSS
     ************************************************************/

    const markScoreStyle = computed((): any => {
      const style: any = {};
      style["font-size"] = `${state.markSize / 2}px !important`;
      style["top"] = `${state.markSize / 5}px`;
      style["left"] = `${props.fieldActivity.score}`.length == 1 ? `${state.markSize / 4}px` : `${state.markSize / 5}px`;
      return style;
    });

    /************************************************************
     * 現在のモードが添削系か判定
     ************************************************************/

    const isTensakuMode = computed(() => {
      return props.drawMode != DrawModeEnum.None && props.drawMode != DrawModeEnum.KeyInput && props.drawMode != DrawModeEnum.SeitouClick
           && props.drawMode != DrawModeEnum.GotouClick && props.drawMode != DrawModeEnum.TokutenClick;
    });

    /************************************************************
     * canvasのBase64文字列をemit
     ************************************************************/

    const setBase64Canvas = () => {
      if(props.fieldActivity.isCanvasEdited){
        const canvas = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
        context.emit("set-base64-canvas", props.idx, canvas.toDataURL("image/png").replace("data:image/png;base64,", ""));
      }
    };

    /************************************************************
     * マウス座標取得
     ************************************************************/

    const getMousePos = (e: MouseEvent) => {
      const x: number = e.offsetX / props.scale;
      const y: number = e.offsetY / props.scale;
      return new Common.Point(x, y);
    };

    /************************************************************
     * canvas MouseDown
     ************************************************************/

    const canvasMouseDown = (e: MouseEvent) => {

      const canvas = e.target as HTMLCanvasElement;
      state.startPos =  getMousePos(e as MouseEvent);
      state.pagePos = state.pagePos = new Common.Point(e.pageX, e.pageY);

      context.emit("field-clicked", props.idx, state.clickedTensakuText);

      if((!isTensakuMode.value || ["t"].includes(props.keyCode)) && !["e", "d"].includes(props.keyCode)){
        // スタンプ系モード
        if(state.isDragging || state.isResizing){
          state.isDragging = false;
          state.isResizing = false;
        }else if(["t"].includes(props.keyCode)){
          // 添削テキスト追加emit
          const param = {point: state.startPos};
          context.emit("add-tensaku-text", param);
          props.fieldActivity.isTextEdited = true;
        }else{
          context.emit("change-selected-tensaku-text", null);
        }
      }else{
        const ctx = canvas.getContext("2d");
        if(ctx == null){
          return;
        }

        // 線描画モード
        if(props.keyCode == "d"){
          state.drawModeCache = props.drawMode;
          context.emit("change-saiten-mode-by-saiten-box", DrawModeEnum.FreeLine);
        }else if(props.keyCode == "e"){
          state.drawModeCache = props.drawMode;
          context.emit("change-saiten-mode-by-saiten-box", DrawModeEnum.Eraser);
        }
        
        state.isDrawing = true;
        ctx.strokeStyle = getStrokeStyle();

        context.root.$nextTick(() => {
          if(props.drawMode == DrawModeEnum.BracesStart || props.drawMode == DrawModeEnum.BracesEnd){
            drawBrace(ctx);
          }
        });
      }      
    };

    /************************************************************
     * canvas MouseMove
     ************************************************************/

    const canvasMouseMove = (e: MouseEvent) => {
      if(!state.isDrawing){
        return;
      }else if(props.drawMode == DrawModeEnum.FreeLine || props.drawMode == DrawModeEnum.Eraser){
        const canvas: HTMLCanvasElement = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
        state.endPos = getMousePos((e as MouseEvent));
        drawLine(canvas.getContext("2d"));
        state.startPos = state.endPos;
      }
    };


    /************************************************************
     * canvas MouseUp
     ************************************************************/

    const canvasMouseUp = (e: MouseEvent) => {
      
      if(!state.isDrawing){
        return;
      }

      if(props.drawMode == DrawModeEnum.Eraser || props.keyCode == "e"){
        const ctx = (e.target as HTMLCanvasElement).getContext("2d");
      }else if(props.drawMode == DrawModeEnum.StraightLine){
        state.endPos = getMousePos(e);
        const ctx = (e.target as HTMLCanvasElement).getContext("2d");
        drawLine(ctx);
      }
      
      state.isDrawing = false;
      setBase64Canvas();

      if(state.drawModeCache != null){
        context.emit("change-saiten-mode-by-saiten-box", state.drawModeCache);
      }
    };

    /************************************************************
     * canvas MouseLeave
     ************************************************************/

    const canvasMouseLeave = (e: MouseEvent) => {
      if(state.isDrawing){
        setBase64Canvas();
      }

      state.isDrawing = false;

      if(props.drawMode == DrawModeEnum.Eraser || props.keyCode == "e"){
        const ctx = (e.target as HTMLCanvasElement).getContext("2d");
      }

      if(state.drawModeCache != null){
        context.emit("change-saiten-mode-by-saiten-box", state.drawModeCache);
        state.drawModeCache = null;
      }
    };


    /************************************************************
     * canvas Touchイベントの座標取得
     ************************************************************/

    const getTouchPos = (t: Touch, canvas: HTMLElement) => {
      const x: number = (t.clientX - canvas.getBoundingClientRect().left) / props.scale;
      const y: number = (t.clientY - canvas.getBoundingClientRect().top) / props.scale;
      return new Common.Point(x, y);
    }

    /************************************************************
     * canvas TouchStart
     ************************************************************/

    const touchStart = (e: TouchEvent) => {

      const canvas = (e as TouchEvent).target as HTMLCanvasElement;
      state.startPos = getTouchPos(e.changedTouches[0], (e as TouchEvent).target as HTMLElement);
      state.pagePos = new Common.Point(e.changedTouches[0].pageX, e.changedTouches[0].pageY);
      state.scrollPos = new Common.Point(canvas.scrollLeft, canvas.scrollTop);

      context.emit("field-clicked", props.idx, state.clickedTensakuText);

      if(state.isTouchScoringEnable && props.drawMode == DrawModeEnum.KeyInput){
        // キー入力の場合
        e.preventDefault();
        state.isTouching = true;
        state.startPos = getTouchPos(e.changedTouches[0], e.target as HTMLCanvasElement);
      }else if(!isTensakuMode.value && props.keyCode != "e" && props.keyCode != "d"){
        // スタンプ系モード
        if(state.isDragging || state.isResizing){
          state.isDragging = false;
          state.isResizing = false;
        }
      }else{
        const ctx = canvas.getContext("2d");

        // 線描画モード
        if(props.keyCode == "d"){
          state.drawModeCache = props.drawMode;
          context.emit("change-saiten-mode-by-saiten-box", DrawModeEnum.FreeLine);
        }else if(props.keyCode == "e"){
          state.drawModeCache = props.drawMode;
          context.emit("change-saiten-mode-by-saiten-box", DrawModeEnum.Eraser);
        }
        
        state.isDrawing = true;
        ctx.strokeStyle = getStrokeStyle();

        context.root.$nextTick(() => {
          if(props.drawMode == DrawModeEnum.BracesStart || props.drawMode == DrawModeEnum.BracesEnd){
            drawBrace(ctx);
          }
        });
      }
    }

    /************************************************************
     * canvas TouchMove
     ************************************************************/

    const touchMove = (e: TouchEvent) => {
      if(!state.isDrawing){
        const canvas: HTMLCanvasElement = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
        const endPos = getTouchPos((e as TouchEvent).changedTouches[0], canvas);
        const scrollEndPos = new Common.Point(canvas.scrollLeft, canvas.scrollTop);
        const limit = 5;
        if(endPos.x - state.startPos.x > limit || endPos.x - state.startPos.x < -limit || endPos.y - state.startPos.y > limit || endPos.y - state.startPos.y < -limit
          || scrollEndPos.x - state.scrollPos.x >  limit || scrollEndPos.x - state.scrollPos.x < -limit || scrollEndPos.y - state.scrollPos.y >  limit || scrollEndPos.y - state.scrollPos.y < -limit){
          state.isScrolling = true;
        }
      }else if(props.drawMode == DrawModeEnum.FreeLine || props.drawMode == DrawModeEnum.Eraser){
        const canvas: HTMLCanvasElement = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
        e.preventDefault();
        state.endPos = getTouchPos(e.changedTouches[0], canvas);

        drawLine(canvas.getContext("2d"));
        state.startPos = state.endPos;
      }else if(state.isTouchScoringEnable && state.isTouching && props.drawMode == DrawModeEnum.KeyInput){
        e.preventDefault();
      }else if(props.drawMode == DrawModeEnum.StraightLine && e instanceof TouchEvent){
        e.preventDefault();
      }
    }

    /************************************************************
     * canvas TouchEnd
     ************************************************************/

    const touchEnd = (e: TouchEvent) => {

      state.isScrolling = false;

      e.preventDefault();

      if(state.isDrawing){
        if(props.drawMode == DrawModeEnum.Eraser){
          const ctx = (e.target as HTMLCanvasElement).getContext("2d");
        }else if(props.drawMode == DrawModeEnum.StraightLine){
          const canvas = e.target as HTMLCanvasElement;
          state.endPos = getTouchPos(e.changedTouches[0], canvas);
          const ctx = canvas.getContext("2d");
          drawLine(ctx);
        }
        state.isDrawing = false;
        setBase64Canvas();
      }else if(state.isTouchScoringEnable && state.isTouching){
        e.preventDefault();
        state.isTouching = false;
        const canvas = e.target as HTMLCanvasElement;
        state.endPos = getTouchPos(e.changedTouches[0], canvas);

        // 始点・終点の距離でフリック判定
        const horizon = state.endPos.x - state.startPos.x;
        const vertical = state.endPos.y - state.startPos.y;
        const diffH = horizon >= 0 ? horizon : -horizon;
        const diffV = vertical >= 0 ? vertical : -vertical;

        if(diffH > diffV && diffH >= 50){
          if(horizon >= 0){
            // 右方向
            context.emit("set-correct-by-child", props.idx, CorrectStateEnum.Seitou);
          }else{
            // 左方向
            context.emit("set-correct-by-child", props.idx, CorrectStateEnum.Gotou);
          }
        }else if(diffV > diffH && diffV >= 50){
          if(vertical >= 0){
            // 下方向
            context.emit("set-correct-by-child", props.idx, CorrectStateEnum.Tokuten);
          }
        }
      }

      if(state.drawModeCache != null){
        context.emit("change-saiten-mode-by-saiten-box", state.drawModeCache);
      }
    }

    /************************************************************
     * ショートカットキーによる自由線・消しゴム処理中断
     * mousemove中にショートカットキーを離した場合に親から呼び出される
     ************************************************************/

    const resetDrawingByKeyUp = () => {
      if(state.drawModeCache != null){
        context.emit("change-saiten-mode-by-saiten-box", state.drawModeCache);
        state.drawModeCache = null;
      }
    }

    /************************************************************
     * strokeStyle設定
     ************************************************************/

    const getStrokeStyle = () => {
      const r = parseInt(props.drawColor.slice(1, 3), 16);
      const g = parseInt(props.drawColor.slice(3, 5), 16);
      const b = parseInt(props.drawColor.slice(5, 7), 16);
      const alpha = props.drawMode == DrawModeEnum.Eraser ? 1.0 : 0.8;

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    /************************************************************
     * canvas 自由線・消しゴム描画
     ************************************************************/

    const drawLine = (ctx: CanvasRenderingContext2D) => {

      if(ctx == null){
        return;
      }

      if(props.drawMode == DrawModeEnum.Eraser){
        ctx.globalCompositeOperation = "destination-out";
        ctx.lineWidth = props.thickness * 16;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.globalAlpha = 1.0;
        ctx.beginPath();
        ctx.moveTo(state.startPos.x, state.startPos.y);
        ctx.lineTo(state.endPos.x, state.endPos.y);
        ctx.stroke();
      }else {
        ctx.globalCompositeOperation = "source-over";
        ctx.lineWidth = props.thickness;
        ctx.beginPath();
        ctx.moveTo(state.startPos.x, state.startPos.y);
        ctx.lineTo(state.endPos.x, state.endPos.y);
        ctx.stroke();
      }

      context.emit("set-canvas-edited", props.idx);
    };

    /************************************************************
     * canvas カッコ描画
     ************************************************************/

    const drawBrace = (ctx: CanvasRenderingContext2D) => {
      const braceSize = 30;
      ctx.lineWidth = props.thickness;
      
      ctx.beginPath();

      if(props.drawMode == DrawModeEnum.BracesStart){
        ctx.moveTo(state.startPos.x + braceSize, state.startPos.y);
        ctx.lineTo(state.startPos.x, state.startPos.y);
        ctx.stroke();
        ctx.moveTo(state.startPos.x, state.startPos.y);
        ctx.lineTo(state.startPos.x, state.startPos.y + braceSize);
        ctx.stroke();
      }else{
        ctx.moveTo(state.startPos.x, state.startPos.y - braceSize);
        ctx.lineTo(state.startPos.x, state.startPos.y);
        ctx.stroke();
        ctx.moveTo(state.startPos.x, state.startPos.y);
        ctx.lineTo(state.startPos.x - braceSize, state.startPos.y);
        ctx.stroke();
      }

      context.emit("set-canvas-edited", props.idx);
      setBase64Canvas();
    }

    /************************************************************
     * 画像上を長押し
     ************************************************************/

    const fieldLongClicked = () => {
      if(!isTensakuMode.value && !state.isScrolling && props.drawMode == DrawModeEnum.KeyInput && context.root.$store.state.isMobile){
        const param = {point: state.startPos};
        context.emit("add-tensaku-text", param);
        props.fieldActivity.isTextEdited = true;
      }
    }

    /************************************************************
     * 番号押下で全体画像表示
     ************************************************************/

    const showPreviewImage = () => {
      context.emit("show-preview-image", props.fieldActivity.examinee.id);
    };

    /************************************************************
     * canvasクリア
     ************************************************************/

    const clearCanvas = () => {
      const canvas = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
      canvas.width = canvas.width;
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {
      // 切り出し画像キャッシュがない場合はAPIでダウンロード
      if(props.fieldActivity.base64Image == null){
        await http.get(`/api/teacher/saiten_input/download_cut_image/${props.sheet_id}/${props.fieldActivity.id}`).then(response => {
          context.emit("set-base64-image", props.idx, response.data.base64_image);
        });
      }

      const canvas = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
      
      if(canvas){
        const ctx = canvas.getContext("2d");

        // canavs画像が存在する場合はロード
        if(props.fieldActivity.base64Canvas != null){
          const canvasImage = new Image();
          canvasImage.src = `data:image/png;base64,${props.fieldActivity.base64Canvas}`;
          canvasImage.onload = () => {
            ctx.drawImage(canvasImage, 0, 0);
            state.isCanvasLeaded = true;
          };
        }else{
          state.isCanvasLeaded = true;
        }
      }

      props.fieldActivity.tensakuTexts.forEach(x => {
        x.base64_text = Common.createBase64Text(x);
      });
    });

    /************************************************************
     * before unmount
     ************************************************************/
    onBeforeUnmount(async () => {
      const canvas = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
      if(canvas != null){
        canvas.width = 0;
        canvas.height = 0;
        canvas.remove();
      }
    });

    /******************************
     * 手書きの色変更監視
     ******************************/

    watch(() => props.drawColor, (newVal, oldVal) => {
      const canvas = document.getElementById(`canvas-${props.idx}-${props.direction}`) as HTMLCanvasElement;
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = newVal;
      ctx.fillStyle = newVal;
    });

    /************************************************************
     * テキスト画像ドラッグ中
     ************************************************************/

    const textDragging = (tensakuText: TensakuText, rect: any) => {
      // 移動距離が5px未満はドラッグ中とは判定しない
      const movedX = rect.left - tensakuText.x * props.scale;
      const movedY = rect.top - tensakuText.y * props.scale;
      state.isDragging = movedX > state.dragMinRange || movedX < -state.dragMinRange || movedY > state.dragMinRange || movedY < -state.dragMinRange;
    }

    /************************************************************
     * テキスト画像ドラッグ終了
     ************************************************************/

    const textDragStop = (tensakuText: TensakuText, rect: any) => {
      dragCheck(tensakuText, rect);
      props.fieldActivity.isTextEdited = true;
    }

    /************************************************************
     * テキスト長押し削除
     ************************************************************/

    const textLongClicked = (tensakuText: TensakuText) => {
      if(state.isStampTouching && !state.isDragging && !state.isResizing && props.drawMode != DrawModeEnum.Delete && (context.root.$store.state.isMobile)){
        // 得点スタンプ削除emit
        const idx = props.fieldActivity.tensakuTexts.indexOf(tensakuText);
        context.emit("delete-tensaku-text", props.idx, idx);
        props.fieldActivity.isTextEdited = true;
      }
    }

    /************************************************************
     * スタンプ mousedown
     ************************************************************/

    const textMouseDown = () => {
      state.isStampTouching = true;
    }

    /************************************************************
     * スタンプ mouseup
     ************************************************************/

    const textMouseUp = () => {
      state.isStampTouching = false;
    }

    /************************************************************
     * テキストスタンプクリック
     ************************************************************/

    const tensakuTextClick = (tensakuText: TensakuText, e: any) => {
      e.stopPropagation();
      
      if(props.drawMode == DrawModeEnum.None || props.drawMode == DrawModeEnum.KeyInput){
        state.clickedTensakuText = tensakuText;
        context.emit("field-clicked", props.idx, state.clickedTensakuText);
        state.clickedTensakuText = null;
        // context.emit("change-selected-tensaku-text", tensakuText);
      }
    }

    /************************************************************
     * 得点スタンプドラッグ範囲チェック
     ************************************************************/

    const dragCheck = (tensakuText: any, rect: any) => {  
      if(rect.left < 0){
        tensakuText.x = tensakuText.x == 1 ? 0 : 1;
      }else if(rect.left + rect.width > props.fieldImageWidth){
        const limitX = (props.fieldImageWidth - rect.width) / props.scale;
        tensakuText.x = tensakuText.x == limitX ? limitX - 1 : limitX;
      }else{
        tensakuText.x = rect.left / props.scale;
      }

      if(rect.top < 0){
        tensakuText.y = tensakuText.y == 1 ? 0 : 1;
      }else if(rect.top + rect.height > props.fieldImageHeight){
        const limitY = (props.fieldImageHeight - rect.height) / props.scale
        tensakuText.y = tensakuText.y == limitY ? limitY - 1 : limitY;
      }else{
        tensakuText.y = rect.top / props.scale;
      }
    }

    return {
      ...toRefs(state),
      DrawModeEnum,
      CorrectStateEnum,
      fieldWrapStyle,
      fieldImageStyle,
      markImageStyle,
      markScoreStyle,
      headerStyle,
      setBase64Canvas,
      canvasMouseDown,
      canvasMouseMove,
      canvasMouseUp,
      canvasMouseLeave,
      touchStart,
      touchMove,
      touchEnd,
      isTensakuMode,
      showPreviewImage,
      resetDrawingByKeyUp,
      clearCanvas,
      textDragging,
      textDragStop,
      textLongClicked,
      textMouseDown,
      textMouseUp,
      tensakuTextClick,
      stampStyle,
      canvasStyle,
      fieldLongClicked,
    }
  }
});
